// extracted by mini-css-extract-plugin
export var icon = "_qz-0";